import { trackClientEvent } from '../../../../trackClientEvent';
import { ITraceEventMarker } from '@faire/web--source/common/pete/TraceEventTracker';

export const eventKey = 'search-narrow_autocomplete_dropdown-click';

/**
 * We are using this to track whenever a narrow autocomplete suggestion is clicked in the search ResultsDropdown
1. query|suggestion-label (e.g. &quot;puff|puffer bag&quot;)
2. c2_category
3. request ID
*/
export function trackSearchNarrowAutocompleteDropdownClick(
  customParameterToken: string,
  customParameterToken2: string,
  customParameterToken3: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    parameters: {
      customParameterToken,
      customParameterToken2,
      customParameterToken3,
    },
  });
}
